import { Collection } from 'modules/core/lib/mobx-rest'

import TeamAnalytics from 'modules/teams/store/models/TeamAnalytics'

class Teams extends Collection<TeamAnalytics> {
  get cacheKey(): string {
    return 'teamsAnalytics'
  }
  model() {
    return TeamAnalytics
  }
}

const singleton: Teams = new Teams()

export default singleton
